<div [dir]="translate.currentLang == 'en' ? 'ltr' : 'rtl'">
    <app-nav-bar
      class="fixed-nav-bar"
      *ngIf="!hideNavbar && accService.userValue != null"
    ></app-nav-bar>
  <router-outlet></router-outlet>
</div>
